import { render, staticRenderFns } from "./MerchantLandingPage.vue?vue&type=template&id=f3e8b37e&"
import script from "./MerchantLandingPage.vue?vue&type=script&lang=js&"
export * from "./MerchantLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports